export const MAINNET_RELAY_API = 'https://api.relay.link';
export const TESTNET_RELAY_API = 'https://api.testnets.relay.link';
export const ASSETS_RELAY_API = 'https://assets.relay.link';
//# sourceMappingURL=servers.js.map